export default "__VITE_ASSET__Bq8m252R__"